<template>
  <div>
    <div class="home-container">
      <module-item
        position-name="main_topleft"
        :size="{ height: 500, heightTag: 320 }"
      />
      <div class="w1200">
        <!-- :style="{ marginTop: (show_main_tag?-84:0) + 'px' }" -->
        <div v-if="show_main_tag" class="banner_nav_list">
          <module-item
            position-name="main_tag"
            :size="{ height: 490, heightTag: 380 }"
          />
        </div>
      </div>
    </div>
    <div class="home-warp">
      <div class="boxwarpPadding">
        <module-title title="特色资源" class="module-title" icon="icon1" />
        <div class="resoure">
          <div class="box-card">
            <module-item
              position-name="main_resource1"
              :size="{ height: 168, width: 227 }"
              show-type="columns"
            />
          </div>
          <div class="box-card">
            <module-item
              position-name="main_resource2"
              :size="{ height: 168, width: 227 }"
              show-type="columns"
            />
          </div>
          <div class="box-card">
            <module-item
              position-name="main_resource3"
              :size="{ height: 168, width: 227 }"
              show-type="columns"
            />
          </div>
          <div class="box-card">
            <module-item
              position-name="main_resource4"
              :size="{ height: 168, width: 227 }"
              show-type="columns"
              @login="submitLogin"
            />
          </div>
          <div class="box-card">
            <module-item
              position-name="main_resource5"
              :size="{ height: 168, width: 227 }"
              show-type="columns"
            />
          </div>
        </div>
      </div>

      <div class="boxwarpPadding">
        <module-title title="虚拟实验" icon="icon7" class="module-title" />
        <div class="virtual_experiment div-layout">
          <ul>
            <li
              v-for="v in syList"
              :key="v.code"
              @click="jumpLink(v.code, 'v1/portal/web/virtualExperiment?code=',false)"
            >
              <div class="virtual_experiment_warp">
                <div class="shade" />
                <div class="virtual_experiment_item">
                  <img
                    :src="require(`@/assets/img/${v.imgUrl}.png`)"
                    class="image"
                    :alt="v.name"
                  >
                  <div class="name">
                    {{ v.name }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="recommend-box">
        <module-title title="精品推荐" icon="icon9" class="module-title" />
        <div class="itemBox">
          <div class="itemBox-item" @click="jumpLink('1', '', true)">
            <img
              src="../../assets/img/recommend-1.png"
              alt=""
            >
          </div>
          <div class="itemBox-item" @click="jumpLink('2', '', true)">
            <img
              src="../../assets/img/recommend-2.png"
              alt=""
            >
          </div>
        </div>
        <div class="itemBox-h5" style="display: none;">
          <div class="itemBox-item" @click="jumpLink('1', '', true)">
            <img
              src="../../assets/img/recommend-1-h5.png"
              alt=""
            >
          </div>
          <div class="itemBox-item" @click="jumpLink('2', '', true)">
            <img
              src="../../assets/img/recommend-21-h5.png"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="boxwarpPadding">
        <module-title title="平台互联" icon="icon8" class="module-title" />
        <div class="platForm">
          <div class="div-layout platForm-item mr10" @click="openWeb(0)">
            <img src="../../assets/img/platform-connect/logo-new.59a73b97.png" alt="">
          </div>
          <div class="div-layout platForm-item ml10" @click="openWeb(1)">
            <img src="../../assets/img/platform-connect/koi_nmg_xxlogo.png" alt="">
          </div>
        </div>
      </div>
      <!-- <div class="boxwarpPadding">
        <module-item position-name="main_virtual_experiment" :size="{height:210,width:284}" show-type="columns" title="走班排课"  @login="submitLogin"/>
      </div> -->
      <adv-item adv-postion-name="index_center_0" class="homeAdv" />
      <div class="boxwarpPadding">
        <!-- :information-type="InformationType"  -->
        <new-list
          :data-list="dataListNews"
          :obj-props="{
            source: 'news',
            link: 'News',
            icon: 'icon2',
            title: '资讯中心',
            type: 'imgTextUpDown',
            loading: loadingNews
          }"
        />
      </div>
      <div class="boxwarpPadding">
        <new-list
          :data-list="dataListAnnouncement"
          :obj-props="{
            source: 'announcement',
            link: 'Announcement',
            title: '活动公告',
            icon: 'icon3',
            type: 'imgTextUpDown',
            loading: loadingAnnouncement
          }"
        />
      </div>
      <adv-item adv-postion-name="index_bottom_0" class="homeAdv" />

      <div class="boxwarpPadding">
        <el-row :gutter="20">
          <el-col :span="12">
            <new-list
              :data-list="dataListSchoolNews"
              :obj-props="{
                source: 'schoolnews',
                link: 'Schoolnews',
                title: '学校动态',
                icon: 'icon4',
                type: 'text',
                loading: loadingSchoolNews
              }"
            />
          </el-col>
          <el-col :span="12">
            <new-list
              :data-list="dataListEduResource"
              :obj-props="{
                source: 'qualityeducation',
                link: 'Qualityeducation',
                icon: 'icon5',
                title: '素质教育',
                type: 'text',
                loading: loadingAnnouncement
              }"
            />
          </el-col>
        </el-row>
      </div>

      <div class="boxwarpPadding">
        <module-title title="学校风采" icon="icon6" class="module-title">
          <div class="right handle-text">
            <a :href="`${SchoolResourcesUrl}/#/homeMain/schoolResources?token=`| urlAddToken" target="_blank">
              更多→</a>
          </div>
        </module-title>
        <module-item
          position-name="main_schools"
          :size="{ height: 520, heightTag: 520 }"
          border-box="none"
        />
      </div>
      <!-- 登录 -->
      <Login v-show="hiddenVariable.dialogEditVisible" @visible="handleClose" />
    </div>
  </div>
</template>

<script>
import Login from '@/views/login/login';
import { mapGetters } from 'vuex';
import { setToken, getToken } from '@/utils/storage'; // getToken from cookie
import ENVIRONMENT from '@/utils/environment';
// 获取API
import getContent from '@/api/content';
import { checkLoginUser } from '@/api/user';
import NewList from '../common/newList.vue';
export default {
  name: 'Home',
  components: {
    Login,
    NewList
  },
  data: () => {
    return {
      SchoolResourcesUrl: ENVIRONMENT.resoureUrl, // 资源门户的校本资源
      activeName: 'iframeindex0',
      loadingAnnouncement: true,
      loadingNews: true,
      loadingEduResource: true,
      loadingSchoolNews: true,
      InformationType: [],
      dataListNews: [],
      dataListEduResource: [],
      dataListSchoolNews: [],
      dataListAnnouncement: [],
      hiddenVariable: {
        dialogEditVisible: false
      },
      syList: [
        { code: 1, name: '物理实验', imgUrl: 'sy1' },
        { code: 2, name: '化学实验', imgUrl: 'sy2' },
        { code: 3, name: '初中生物实验', imgUrl: 'sy3' },
        { code: 4, name: '高中生物实验', imgUrl: 'sy4' },
        { code: 5, name: '小学科学教学', imgUrl: 'sy5' }
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'moudelsList', 'activeNameTag']),
    show_main_tag() {
      // 标签图 例如云上成果智慧优课省市资源精品教育
      return (
        this.moudelsList.main_tag &&
        (this.moudelsList.main_tag.showType === 1 ||
          (this.moudelsList.main_tag.list.length > 0 &&
            (this.moudelsList.main_tag.moduleType === 3 ||
              (this.moudelsList.main_tag.moduleType === 2 &&
                this.moudelsList.main_tag.list[0].moduleCode) ||
              this.moudelsList.main_tag.moduleType === 10)))
      );
    }
  },
  watch: {
    $route(route) {
      if (route.query.token) {
        setToken(route.query.token);
        if (getToken()) this.getParams(this.$route.query);
      }
    }
  },
  mounted() {
    this.init(); // 初实化
    this.handleScroll();
  },
  methods: {
    jumpLink(val, urlLink, type) {
      if (val) {
        const url = ENVIRONMENT.BASE_API + urlLink + `${val}&token=`;
        if (getToken()) {
          if (type) {
            checkLoginUser(val.substr(0, 1)).then(res => {
              return window.open(val === '1' ? (res.data + getToken()) : res.data);
            });
          } else {
            window.open(this.$util.urlAddToken(url));
          }
        } else {
          this.$message({ type: 'warning', message: '登录后才可查看该内容' });
          setTimeout(() => {
            this.submitLogin();
          }, 1000);
        }
      }
    },
    handleScroll() {
      var flag = true;
      window.addEventListener('scroll', () => {
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        if (top >= 350 && flag && this.activeNameTag === 'iframeindex0') {
          this.$util.doIFrameFunc('init', null, 'main_tag_iframeindex0');
          flag = false;
        }
        if (top === 0) flag = true;
      });
    },
    getParams() {
      this.$store.dispatch('GetUserSso').then(() => {
        this.$router.push('/');
      });
    },
    init() {
      this.$store.dispatch('getModules'); // 获取模块
      this.getTypeAll();
      this.getInfoNews();
      this.getEduResource();
      this.geSchoolNews();
      this.getInfoAnnouncement();
      if (this.$route.query.token) {
        setToken(this.$route.query.token);
        if (getToken()) this.getParams(this.$route.query);
      }
    },
    // 获取资讯全部分类
    getTypeAll() {
      getContent['geteduInformationClassifys']().then(res => {
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.InformationType = [];
        } else {
          this.InformationType = res.data.slice(0, 6);
        }
      });
    },

    // 获取列表资讯
    getInfoNews() {
      this.loadingNews = true;
      var option = {
        pageNum: 1,
        pageSize: 10
      };
      getContent['geteduInformationListHome'](option).then(res => {
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.dataListNews = [];
        } else {
          this.dataListNews = res.data.slice(0, 4);
        }
        this.loadingNews = false;
      });
    },
    // 获取列表素质教育
    getEduResource() {
      this.loadingEduResource = true;
      var option = {
        pageNum: 1,
        pageSize: 10
      };
      getContent['geteduResourceContentsListHome'](option).then(res => {
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.dataListEduResource = [];
        } else {
          this.dataListEduResource = res.data.slice(0, 4);
        }
        this.loadingEduResource = false;
      });
    },
    // 获取列表学校动态
    geSchoolNews() {
      this.loadingSchoolNews = true;
      var option = {
        pageNum: 1,
        pageSize: 10
      };
      getContent['getSchoolnewsListHome'](option).then(res => {
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.dataListSchoolNews = [];
        } else {
          this.dataListSchoolNews = res.data.slice(0, 4);
        }
        this.loadingSchoolNews = false;
      });
    },
    // 获取列表公告
    getInfoAnnouncement() {
      this.loadingAnnouncement = true;
      var option = {
        pageNum: 1,
        pageSize: 10
      };
      getContent['geteduNoticeContentsListHome'](option).then(res => {
        if (
          res.data === null ||
          res.data === '' ||
          res.data === 'undefind' ||
          (res.data.list && res.data.list < 1)
        ) {
          this.dataListAnnouncement = [];
        } else {
          this.dataListAnnouncement = res.data.slice(0, 4);
        }
        this.loadingAnnouncement = false;
      });
    },
    // 登录
    submitLogin() {
      this.hiddenVariable.dialogEditVisible = true;
    },
    // 关闭登录弹窗
    handleClose() {
      this.hiddenVariable.dialogEditVisible = false;
    },
    openWeb(type) {
      switch (type) {
        case 0:
          window.open('https://basic.smartedu.cn/');
          break;
        case 1:
          window.open('https://basic.nmg.smartedu.cn/');
          break;
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.el-select-dropdown__item.selected {
  background-color: #f5f7fa;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #007afc;
  color: #fff;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.home-warp {
  width: 1200px;
  margin: 0 auto;
}
.recommend-box {
  .itemBox {
    display: flex;
    justify-content: space-between;
  }
    .itemBox-item {
    width: 590px;
    height: 250px;
    text-align: center;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
      transform: scale(1);
      transition: transform 0.2s;
    }
    &:hover img {
      transform: scale(1.1);
    }
  }
}
.home-container {
  background-color: #f0f2f5;
  width: 100%;
  position: relative;

  .home-left {
    max-width: 1920px;
    height: 500px;
    // border: 1px solid #fff;
    z-index: 1;

    .image {
      width: 1920px;
      height: 500px;
      object-fit: contain;
    }
  }

  .banner_nav_list {
    position: relative;
    top: 0;
    z-index: 9;
    border-radius: 8px;
  }
}

.type {
  .item {
    width: 33.33%;
    display: inline-block;
    text-align: center;

    a {
      display: block;
      background: #e0f1ff;
      margin: 10px;
      padding: 20px 0;
      border-radius: 4px;
    }

    .iconWarp {
      display: inline-block;
    }

    .icon {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;

      .image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    p {
      color: #0084e9;
      text-align: center;

      span {
        max-width: 70px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
        display: inline-block;
        -webkit-line-clamp: 1;
      }
    }
  }
}

.resoure {
  display: flex;
}

.virtual_experiment {
  text-align: center;
  padding: 22px 0 30px 0;

  li {
    display: inline-block;
    width: 20%;
    cursor: pointer;

    .name {
      font-weight: 500;
      font-size: 26px;
      padding-top: 20px;
    }

    .virtual_experiment_warp {
      margin: 0 30px;
      padding-top: 15px;
      padding-bottom: 5px;
      position: relative;
    }

    .virtual_experiment_item {
      position: relative;
      z-index: 2;
      border-radius: 6px;
    }

    .shade {
      opacity: 0;
      filter: alpha(opacity=0);
      position: absolute;
      z-index: 1;
      top: 0px;
      right: 0px;
      bottom: 0;
      left: 0px;
      background-color: #fff;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
    }

    .shade:after {
      content: '';
      position: absolute;
      top: -1px;
      right: -1px;
      bottom: -1px;
      left: -1px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      border-radius: 5px;
    }

    .virtual_experiment_item:hover {
      -webkit-transform: translateY(-5px);
      -moz-transform: translateY(-5px);
      transform: translateY(-5px);
    }

    &:hover .shade {
      opacity: 1;
    }

    &:hover img {
      -webkit-transform: scale(1.05);
      -moz-transform: scale(1.05);
      -ms-transform: scale(1.05);
      transform: scale(1.05);
    }
  }
}
.platForm {
  display: flex;
  .platForm-item {
    width: 50%;
    text-align: center;
    cursor: pointer;
    img {
      width: 477px;
      margin-top: 15px;
      transform: scale(1);
      transition: transform 0.2s;
    }
    &:hover img {
      transform: scale(1.1);
    }
  }
  .mr10 {
    margin-right: 10px;
  }
  .ml10 {
    margin-left: 10px;
  }
}
</style>
